import Field from 'components/Form/Field';
import FormHeader from 'components/Form/FormHeader';
import KeyValue from 'components/Layout/KeyValue';
import Link from 'components/Link';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import Notification from 'components/Notification';
import SectionHeader from 'components/SectionHeader';
import Value from 'components/Value';
import useMessage from 'hooks/useMessage';
import {useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

import {TRNDocumentTypes} from '../types';

export type TRNDBackendDataView = Backend<TRNDocumentTypes, 'canEdit'>;

const View = () => {
    const {appPermissions, data, flags} = useBackend<TRNDBackendDataView>();

    const {successMessage} = useMessage<'successMessage'>();

    const [showNotification, setShowNotification] = useState(!!successMessage);

    const {t} = useTranslation('Document.TaxRegistrationNumberDisplay');

    return (
        <div>
            {showNotification && (
                <Notification
                    className="mb-4"
                    onClick={() => setShowNotification(false)}
                    size="sm"
                    type="success"
                >
                    {successMessage}
                </Notification>
            )}
            <NavigationTabs.DocumentSettings
                flags={flags}
                selection="taxRegistrationNumber"
            />
            <FormHeader
                link={{
                    disabled: !appPermissions.canEdit.allowed,
                    href: window.Urls.react_tax_registration_number_edit(),
                    icon: 'edit',
                    kind: 'secondary',
                    label: t('edit'),
                }}
                subtitle={t('subTitle')}
                title={t('title')}
                tooltipMessage={appPermissions.canEdit.failureReason}
            />
            <div>
                <SectionHeader
                    level={2}
                    subtitle={
                        <Trans
                            components={[
                                <Link
                                    href={window.Urls.partner_item_view()}
                                    key={0}
                                >
                                    {' '}
                                </Link>,
                            ]}
                            i18nKey="partnerInstruction"
                            ns="Document.TaxRegistrationNumberDisplay"
                            t={t}
                        />
                    }
                    title={t('partnerTitle')}
                />
                <KeyValue className="mt-4" keyWidth={8}>
                    {data.partnerTrnSettings.map((documentType) => (
                        <Field
                            key={documentType.documentType}
                            label={documentType.label}
                            type="value"
                        >
                            <Value
                                value={{
                                    type: 'boolean',
                                    value: documentType.enabled,
                                }}
                            />
                        </Field>
                    ))}
                </KeyValue>
            </div>
            <div className="mt-12">
                <SectionHeader
                    level={2}
                    subtitle={t('clientInstruction')}
                    title={t('clientTitle')}
                />
                <KeyValue className="mt-4" keyWidth={8}>
                    {data.clientTrnSettings.map((documentType) => (
                        <Field
                            key={documentType.documentType}
                            label={documentType.label}
                            type="value"
                        >
                            <Value
                                value={{
                                    type: 'boolean',
                                    value: documentType.enabled,
                                }}
                            />
                        </Field>
                    ))}
                </KeyValue>
            </div>
        </div>
    );
};

export default View;
